/**
 * @return  ['insights']
 * */
export const insightsKey = () => ["insights"];

export const insightsWithParamsKey = ({ queryParams }) => [...insightsKey(), queryParams];
